import React from 'react';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faAngleRight,
  faUnlink,
} from '@fortawesome/fontawesome-free-solid';
import { faTrashAlt } from '@fortawesome/fontawesome-free-regular';
import { Link } from 'react-router-dom';

import { CardHeader } from './Card';
import LineGroupsContainer from '../containers/LineGroupsContainer';
import LineFormContainer from '../containers/LineFormContainer';

export default class LineCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { props } = this;
    const sectionName = props.section
      ? props.section.label || props.section.type || `Section ${props.sectionIndex + 1}`
      : '';
    if (this.props.line) {
      return (
        <div>
          <div className="card mb-3 paper-shadow">
            <div className="card-body pb-0">
              <CardHeader
                title={
                  <div>
                    <Link to={`/song/${props.sectionIndex}`}>{sectionName}</Link>
                    <span className="px-2 text-muted small">
                      <FontAwesomeIcon icon={faAngleRight} />
                    </span>
                    {`Line ${props.lineIndex + 1}`}
                  </div>
                }
              />
              {/*
              {props.section && props.sectionIndex >= 0 ? (
                <div>
                  <div className="text-center">
                    <Link to={`/song/${props.sectionIndex}`}>
                      {props.section.label ||
                        props.section.type ||
                        `Section ${props.sectionIndex + 1}`}
                    </Link>
                  </div>
                  {props.lineIndex >= 0 && (
                    <div className="d-flex w-100 justify-content-between mb-3">
                      <Link
                        to={`/song/${props.sectionIndex}/${props.lineIndex - 1}`}
                        className="btn btn-outline-dark btn-sm"
                      >
                        <FontAwesomeIcon icon={faChevronLeft} />
                        Line {props.lineIndex}
                      </Link>
                      <h5 className="text-center">
                        <div>{`Line ${props.lineIndex + 1}`}</div>
                      </h5>
                      <Link
                        to={`/song/${props.sectionIndex}/${props.lineIndex + 1}`}
                        className="btn btn-outline-dark btn-sm"
                        disabled={props.lineIndex + 1 >= props.section.lines.length}
                      >
                        Line {props.lineIndex + 2} &gt;
                      </Link>
                    </div>
                  )}
                </div>
              ) : (
                <div />
              )}
            <hr /> */}
            </div>
            <LineFormContainer
              line={this.props.line}
              location={this.props.location}
              history={this.props.history}
              footerLeft={
                <div className="dropdown">
                  <a
                    className="card-link dropdown-toggle text-danger"
                    title="Delete / Remove"
                    href="#delete-remove"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </a>
                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {props.section && props.lineIndex >= 0 ? (
                      <a
                        className="dropdown-item pl-3"
                        href="#remove-line"
                        onClick={e => props.onRemove(e, props.section.id, props.lineIndex)}
                      >
                        <FontAwesomeIcon icon={faUnlink} className=" mr-3" />Remove from{' '}
                        {sectionName}
                      </a>
                    ) : (
                      <span className="dropdown-item pl-3">
                        <FontAwesomeIcon icon={faUnlink} className=" mr-3" />Remove from{' '}
                        {sectionName}
                      </span>
                    )}
                    <div className="dropdown-divider" />
                    <a
                      className="dropdown-item text-danger pl-3"
                      href="#delete-line"
                      onClick={e => props.onDelete(e, props.line.id)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} className=" mr-3" />Delete
                    </a>
                  </div>
                </div>
              }
              footerCenter={
                <div className="d-flex">
                  <Link
                    to={props.prevLink || `/song/${props.sectionIndex}/${props.lineIndex}`}
                    className={`px-3 card-link ${props.prevLink ? '' : 'text-muted'}`}
                  >
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </Link>
                  {props.position && (
                    <div className="smalld text-muted text-center">
                      {props.position.n} / {props.position.total}
                    </div>
                  )}
                  <Link
                    to={props.nextLink || `/song/${props.sectionIndex}/${props.lineIndex}`}
                    className={`px-3 card-link ${props.nextLink ? '' : 'text-muted'}`}
                  >
                    <FontAwesomeIcon icon={faChevronRight} />
                  </Link>
                </div>
              }
            />
          </div>

          <LineGroupsContainer
            line={this.props.line}
            onSelectAlt={this.props.onSelectAlt}
            section={this.props.section}
            lineIndex={this.props.lineIndex}
          />
        </div>
      );
    }
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/components/LineCard.js